import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';

const entityTypeOptions = [
    { value: '', label: 'All Entity Types' },
    { value: 'Customer', label: 'Customer' },
    { value: 'Product', label: 'Product' },
    { value: 'Price', label: 'Price' },
];

const syncStatusOptions = [
    { value: '', label: 'All Sync Statuses' },
    { value: 'Synced', label: 'Synced' },
    { value: 'Pending', label: 'Pending' },
    { value: 'Failed', label: 'Failed' },
    { value: 'Conflict', label: 'Conflict' },
];

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="entityType"
                label="Entity Type"
                data={entityTypeOptions}
                component={FormikRadioGroup}
                my="md"
            />
            <Field
                name="syncStatus"
                label="Sync Status"
                data={syncStatusOptions}
                component={FormikRadioGroup}
                my="md"
            />
        </>
    );
};
